import { useLssFromMapTutorialState } from "@/tools/create/lss-from-map/context/LssFromMapTutorialContext";
import { PointsStageSidebar } from "@/tools/create/lss-from-map/sidebar/stages/PointsStageSidebar";
import { PolygonStageSidebar } from "@/tools/create/lss-from-map/sidebar/stages/PolygonStageSidebar";
import { SettingsStageSidebar } from "@/tools/create/lss-from-map/sidebar/stages/SettingsStageSidebar";
import { CreateLssFromMapStage, PointWithMetadata } from "@/tools/create/lss-from-map/types";
import { notification } from "antd";
import { LatLngLiteral, Polygon } from "leaflet";
import { merge } from "lodash/fp";
import { useState } from "react";
export interface CreateLssFromMapSidebarProps {
  arePointsValid: boolean;
  isAreaValid: boolean;
  points: PointWithMetadata[];
  polygons: Polygon[];
  setFocusPoint: (value: LatLngLiteral) => void;
  setPolygons: (value: Polygon[]) => void;
  setStage: (value: CreateLssFromMapStage) => void;
  stage: CreateLssFromMapStage;
}
export const CreateLssFromMapSidebar = ({
  arePointsValid,
  isAreaValid,
  points,
  polygons,
  setFocusPoint,
  setPolygons,
  setStage,
  stage
}: CreateLssFromMapSidebarProps) => {
  const [polygonName, setPolygonName] = useState(polygons[0]?.options.attribution || "");
  const {
    addressLookup,
    polygonNameInput,
    generateGridBtn,
    confirmSettingsBtn,
    settingsContent,
    settingsScrollArea,
    financialSectionNarrow,
    financialSectionWide,
    proceedToReviewBtn,
    setSettingsRefs,
    expandFinancialSection
  } = useLssFromMapTutorialState();
  const onPolygonContinue = () => {
    // Assign our name to the first polygon.
    if (polygons.length !== 1) {
      notification.error({
        message: "Number of polygons must be exactly 1 to continue."
      });
      return;
    }
    setPolygons(polygons.map(polygon => merge(polygon, {
      options: {
        attribution: polygonName.trim()
      }
    } as Partial<Polygon>)));
    setStage("points");
  };
  return <>
      {stage === "polygon" && <PolygonStageSidebar isAreaValid={isAreaValid} onContinue={onPolygonContinue} polygonName={polygonName} setFocusPoint={setFocusPoint} setPolygonName={setPolygonName} refs={{
      addressLookup,
      polygonNameInput,
      generateGridBtn
    }} />}
      {stage === "points" && <PointsStageSidebar arePointsValid={arePointsValid} onContinue={() => setStage("settings")} onGoBack={() => setStage("polygon")} points={points} refs={{
      confirmSettingsBtn
    }} />}
      {stage === "settings" && <SettingsStageSidebar onGoBack={() => setStage("points")} points={points} polygons={polygons} financialSectionOpen={expandFinancialSection} refs={{
      settingsContent,
      settingsScrollArea,
      financialSectionNarrow,
      financialSectionWide,
      proceedToReviewBtn,
      onSettingsRefs: setSettingsRefs
    }} />}
    </>;
};